import { IGenEq, EGenMode, eqToMulti, IGenMulti, QMulti } from '@educraft/base';
import { IExercise, ExerciseData, addResult } from '../exercise';
import { PdfUnit, PdfRect, PdfBrush, ETextAlign } from '../../pdf/pdf';
import { GUtil } from '../../pdf/gutil';

export class ExerciseAbc0 implements IExercise {
  readonly name = 'ExerciseAbc0';
  readonly fixedHeight = 0;
  readonly noWindow = false;
  readonly injectEq = false;
  readonly injectAbc = true;

  private rowHeight = PdfUnit.FromMillimeters(6);
  private squareSize = PdfUnit.FromMillimeters(5);
  private margin = PdfUnit.FromMillimeters(1);

  draw(data: ExerciseData): void {
    const selAbc = data.item.selAbc.length > 0 ? data.item.selAbc : data.item.selEq;
    if (selAbc.length === 0) return;

    // Resolve selected generators and create a combined multi generator
    const generators: IGenMulti[] = selAbc.map((name) => {
      const eq = data.provider.getOne<IGenEq>(EGenMode.GenEq, name);
      return eqToMulti(eq);
    });

    const combinedGen: IGenMulti = {
      generate(genData) {
        const idx = genData.random.next(0, generators.length);
        return generators[idx].generate(genData);
      },
    };

    let top = data.rect.y;

    while (true) {
      const item: QMulti = combinedGen.generate(data.data);
      const height = this.rowHeight * (item.texts.length + item.answers.length);

      if (top + height > data.rect.bottom) break;

      addResult(data, item.texts.join(' '), String.fromCharCode(item.answerIndex + 65)); // 65 = 'A'

      // Draw question texts
      for (let i = 0; i < item.texts.length; i++) {
        const text = item.texts[i];
        data.page.drawString(
          text,
          GUtil.exerciseFont,
          PdfBrush.Black,
          null,
          new PdfRect(data.rect.x, top, data.rect.width, this.rowHeight),
          ETextAlign.CenterLeft
        );
        top += this.rowHeight;
      }

      // Draw answer options with checkbox squares
      for (let i = 0; i < item.answers.length; i++) {
        const r1 = new PdfRect(
          data.rect.x,
          top + (this.rowHeight - this.squareSize) / 2,
          this.squareSize,
          this.squareSize
        );
        const rX = r1.right + this.margin;
        const r2 = new PdfRect(rX, top, data.rect.right - rX, this.rowHeight);

        data.colorSchema.drawResult(data.page, r1);
        data.page.drawRectangle(GUtil.basePen, null, r1);

        data.page.drawString(
          item.answers[i],
          GUtil.exerciseFont,
          PdfBrush.Black,
          null,
          r2,
          ETextAlign.CenterLeft
        );
        top += this.rowHeight;
      }

      top += this.rowHeight * 0.3;
    }
  }
}
